import * as Model from '../../models/models';


export class PaymentSearchViewModel {

    policyholders:Array<Model.IPolicyholder>;
    paymentSummaries: Array<Model.IPaymentSummary>;
    isDataGridLoading: boolean;
    showNoSearchMatchMessage: boolean = false;
    decisionTypeCodes:Array<string> = ["","ACCEPT","CANCEL","DECLINE","ERROR","REJECT","REVIEW"];
    paymentSearchCriteria: Model.IPaymentSummarySearchCriteria = new Model.PaymentSummarySearchCriteria();
    searchResults:Array<PaymentSearchResult>;

}

export class PaymentSearchResult {

    paymentId: number;
    paymentResponseId:string;
    organizationName: string;  
    billingAccountNumber: string;
    paymentAmount: number;
    requestedAt: Date;
    decisionType: string;
    reasonCode: string;
    requestOriginType:string;
    paymentType:string;
    systemReferenceNumber:string;
    paymentAcct:string;
    
}